var _path, _circle, _circle2, _circle3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuDotsIcon = function SvgMenuDotsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_388",
    "data-name": "Grupo 388",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2225",
    "data-name": "Caminho 2225",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22.154A10.154,10.154,0,1,1,22.154,12,10.152,10.152,0,0,1,12,22.154Z",
    fill: "#4b4b4b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_50",
    "data-name": "Elipse 50",
    cx: 1.655,
    cy: 1.655,
    r: 1.655,
    transform: "translate(5.289 10.345)",
    fill: "#4b4b4b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_51",
    "data-name": "Elipse 51",
    cx: 1.655,
    cy: 1.655,
    r: 1.655,
    transform: "translate(10.345 10.345)",
    fill: "#4b4b4b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_52",
    "data-name": "Elipse 52",
    cx: 1.655,
    cy: 1.655,
    r: 1.655,
    transform: "translate(15.4 10.345)",
    fill: "#4b4b4b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuDotsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-dots-icon.d68ee8d1.svg";
export { ForwardRef as ReactComponent };